declare global {
   interface Window {
      loadGoogleAnalytics: (code: string) => void;
   }
}

function useGoogleAnalytics(code: string): void {
   if (import.meta.env.SSR) return;

   if (!code) {
      console.error("Google analytics code not provided");
      return;
   }

   window.loadGoogleAnalytics(code);
}

export { useGoogleAnalytics };
